import { createRouter, createWebHistory } from 'vue-router'
import {useAuthStore} from "@/store/useAuthStore";
import {ROUTES_PARENT} from "@/config/constants";

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/LoginPage.vue')
  },
  {
    path: '/#',
    name: 'landing',
    redirect: {name: 'dashboard'},
    meta: {requiresAuth: true},
    component: () => import('../views/layout/RouteViewContainer.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard/Dashboard.vue'),
      },
      {
        path: '/journal',
        name: 'journals',
        redirect: {name: 'journalsList'},
        children: [
          {
            path: 'list',
            name: 'journalsList',
            component: () => import('../views/accounting/journals/JournalVoucherListing.vue'),
          },
           {
             path: ':code',
             name: 'journalDetails',
             props: true,
             component: () => import('../views/accounting/journals/JournalVoucherDetails.vue'),
           },
        ]
      },
        {
            path: '/payable-receivable',
            name: 'payables',
            props: true,
            redirect: {name: 'payablesList'},
            children: [
                {
                    path: ':type/list',
                    name: 'payablesList',
                    props: true,
                    component: () => import('../views/accounting/payables/PayablesListing.vue'),
                },
                {
                    path: ':type/:code',
                    name: 'payableDetails',
                    props: true,
                    component: () => import('../views/accounting/payables/PayableReceivableDetails.vue'),
                },
            ]
        },
        {
            path: '/payment-receipt',
            name: 'paymentsReceipts',
            props: true,
            redirect: {name: 'paymentsReceiptsList'},
            children: [
                {
                    path: ':type/list',
                    name: 'paymentsReceiptsList',
                    props: true,
                    component: () => import('../views/accounting/payments/PaymentsReceiptsListing.vue'),
                },
                {
                    path: ':type/:code',
                    name: 'paymentReceiptDetails',
                    props: true,
                    component: () => import('../views/accounting/payments/PaymentReceiptDetails.vue'),
                },
            ]
        },
        {
            path: '/trial-balance',
            name: 'trialBalance',
            component: () => import('../views/reports/trial-balance/TrialBalance.vue'),
        },
        {
            path: '/balance-sheet',
            name: 'balanceSheet',
            component: () => import('../views/reports/balance-sheet/BalanceSheet.vue'),
        },
      {
         path: '/profit-and-loss',
         name: 'profitAndLoss',
         component: () => import('../views/reports/profit-and-loss/ProfitAndLoss.vue'),
      },
      {
         path: '/inventory',
         name: 'inventory',
         component: () => import('../views/reports/inventory/Inventory.vue'),
      },
      {
        path: '/chart-of-accounts',
        name: 'chartOfAccounts',
        component: () => import('../views/setup/chart-of-accounts/ChartOfAccounts.vue'),
      },
      {
         path: '/account-mappings',
         name: 'accountMappings',
         component: () => import('../views/setup/account-mapping/AccountMappings.vue'),
      },
      {
        path: '/entities',
        name: 'entities',
        component: () => import('../views/setup/entities/Entities.vue'),
      },
      {
        path: '/branches',
        name: 'branches',
        component: () => import('../views/setup/branches/Branches.vue'),
      },
      {
        path: '/users',
        name: 'users',
        redirect: {name: 'usersList'},
        component: () => import('../views/setup/users/Users.vue'),
        children: [
              {
                  path: 'list',
                  name: 'usersList',
                  component: () => import('../views/setup/users/UsersList.vue'),
              },
              {
                  path: ':code',
                  name: 'userDetails',
                  props: true,
                  component: () => import('../views/setup/profile/ProfileForm.vue'),
              },
          ]
      },
      {
         path: '/profile',
         name: 'profile',
         component: () => import('../views/setup/profile/Profile.vue'),
      },
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Page404',
    component: () => import('../views/misc/PageNotFound.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async(to, from, next) => {
    const authStore = useAuthStore()
    const isLoggedIn = authStore.isLoggedIn

    if (to.meta.requiresAuth && !isLoggedIn) {
        authStore.clearAuth()
        return next({ name: 'login' })
    }

    if(isLoggedIn) {
        if(to.name === 'login') return next({name: 'dashboard'})
        else {
            let module = to.matched[1].name
            // NOTE: parent of route is being get as the structure of the router is not nested
            let module_parent = getRouteParent(module)
            //TODO: if route is for payable and receivable check param type and determine getAccess
            //let permission_route_code = ROUTES_EQUIVALENT_PERM_CODE[module] ?? null
            // check if parent of route being navigated to is accessible by the user
            if(module_parent && !authStore.getAccess('module', module_parent)) return next({name: 'dashboard'})
            // else if(permission_route_code && !authStore.getAccess('fn', permission_route_code, 'view')) {
            //     return next({name: 'dashboard'})
            // }
            return next()
        }
    }

    return next()
})

function getRouteParent(routeName) {
    for(const key of Object.keys(ROUTES_PARENT)) {
        if(ROUTES_PARENT[key].includes(routeName)) return key
    }

    return null
}

export default router
